var _path, _g, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3472_1153",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 1,
    width: 13,
    height: 12
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 1.16675H14.8313V12.7321H2.5V1.16675Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3472_1153)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.66468 2.16675C6.33468 2.16675 4.71068 3.99208 4.71068 5.63008C4.71068 7.01608 4.32601 7.65675 3.98601 8.22208C3.71334 8.67608 3.49801 9.03475 3.49801 9.81408C3.60934 11.0714 4.43934 11.7321 8.66468 11.7321C12.8667 11.7321 13.7227 11.0421 13.8333 9.77075C13.8313 9.03475 13.616 8.67608 13.3433 8.22208C13.0033 7.65675 12.6187 7.01608 12.6187 5.63008C12.6187 3.99208 10.9947 2.16675 8.66468 2.16675ZM8.66468 12.7321C5.54734 12.7321 2.73001 12.5121 2.50001 9.85675C2.49801 8.75808 2.83334 8.19941 3.12934 7.70741C3.42868 7.20875 3.71068 6.73875 3.71068 5.63008C3.71068 3.47475 5.70134 1.16675 8.66468 1.16675C11.628 1.16675 13.6187 3.47475 13.6187 5.63008C13.6187 6.73875 13.9007 7.20875 14.2 7.70741C14.496 8.19941 14.8313 8.75808 14.8313 9.81408C14.5987 12.5121 11.782 12.7321 8.66468 12.7321Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.63218 15.5002H8.63085C7.88351 15.4995 7.17618 15.1702 6.63951 14.5722C6.45485 14.3675 6.47151 14.0508 6.67685 13.8668C6.88218 13.6815 7.19818 13.6982 7.38285 13.9042C7.72818 14.2888 8.17151 14.5002 8.63151 14.5002H8.63218C9.09418 14.5002 9.53951 14.2888 9.88551 13.9035C10.0708 13.6988 10.3868 13.6822 10.5915 13.8668C10.7968 14.0515 10.8135 14.3682 10.6288 14.5728C10.0902 15.1708 9.38151 15.5002 8.63218 15.5002Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.e7c1193e39a0ea705f2e4e85fc3d4aa5.svg";
export { ForwardRef as ReactComponent };